export class CostCenterReportResult {
  name: string;
  rowSpan: number;
  subCostCenterModel: CostCenterReportResult[];
  timeCostModel: BaseCostModel;
  kilometerCostModel: BaseCostModel;
  fixedFeeCostModel: BaseCostModel;
  totalCostModel: BaseCostModel;
  penaltyCostModel: BaseCostModel;
  costExpenseCostModel: BaseCostModel;
  costAndExpenseList: CostExpoenseModel[];
  groupName: string;
  levelNo: number;
  currencySymbol: string;

  column1: string;
  column2: string;
  column3: string;
  column4: string;
  column5: string;
  column6: string;
  distanceCost: string;
  timeCost: string;
  fixedCost: string;
  totalExVat: string;
  totalIncVat: string;
  penalty: string;
}

export class CostExpoenseModel {
  key: number;
  value: number;
  valueFormatted: string;
  caption: string;
}

export class BaseCostModel {
  costExVat: number;
  costInVat: number;
  costExVatFormatted: string;
  costInVatFormatted: string;
}

export class CostTypeModel {
  public isChecked: boolean;
  public costTypeHashId: string;
  public name: string;
  public isDefaultCostType: boolean = false;
  public defaultName: string;
}

export const DefaultCostTypeList: CostTypeModel[] = [
  {
    name: "Distance",
    defaultName: "DISTANCE",
    isDefaultCostType: true,
    costTypeHashId: "DISTANCE",
    isChecked: true
  },
  {
    name: "Time",
    defaultName: "TIME",
    isDefaultCostType: true,
    costTypeHashId: "TIME",
    isChecked: true
  },
  {
    name: "Fixed Fee",
    defaultName: "FIXEDFEE",
    isDefaultCostType: true,
    costTypeHashId: "FIXEDFEE",
    isChecked: true
  },
  {
    name: "Penalties",
    defaultName: "PENALTIES",
    isDefaultCostType: true,
    costTypeHashId: "PENALTIES",
    isChecked: true
  },
  {
    name: "Subscription",
    defaultName: "SUBSCRIPTIONFEE",
    isDefaultCostType: true,
    costTypeHashId: "SUBSCRIPTIONFEE",
    isChecked: true
  }
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/cost-center-report.model.ts